export const removeFirstHash = (str: string) => (str.startsWith('#') ? str.slice(1) : str);
